import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import SignaturePad from "signature_pad";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import {Button} from "@material-ui/core";
import {isEmpty} from "../../../lib/utils";
import CreateIcon from "@material-ui/icons/Create";
import ClearIcon from '@material-ui/icons/Clear';

const useStyles = makeStyles((theme) => ({
  section: {
    marginTop: "30px",
    padding: "20px 0",
    lineHeight: 1.6,
    borderTop: "1px solid #333",
    "& p": {
      marginTop: "10px",
    },
  },
  title: {
    padding: "15px 0",
    fontSize: "20px",
    fontWeight: 700,
    textAlign: "center",
  },
  bold: {
    fontWeight: 700,
  },
  box: {
		margin: "15px 0",
		padding: "15px",
		border: "1px solid #333",
		"& > ul > li": {
			marginTop: "10px"
		},
	},
	alignRight: {
		textAlign: "right"
	},
	signPad: {
		marginTop: "20px",
		textAlign: "right",
		"& .signature": {
			display: "inline-block",
			width: "335px",
			height: "200px",
			border: "1px dotted #333"
		}
	}
}));

let canvas;
let signaturePad;

const UserSurvey05 = ({ mode, userName, projectName, idx, date, signImg, signImgList }) => {
  const classes = useStyles();
  const [agree, setAgree] = useState({
		agree01: (!isEmpty(signImg)) ? 'yes' : '',
		agree02: (!isEmpty(signImg)) ? 'yes' : ''
	});

  useEffect(() => {
		if (mode === 'viewer') {
			canvas = document.querySelector(`#signature${idx}`);
			signaturePad = new SignaturePad(canvas);
		}		
	}, [idx, mode]);

  const handleChange = (e) => {
		setAgree({
			...agree,
			[e.target.name]: e.target.value
		})
	}

  const saveSign = (e) => {
		if (agree.agree01 === 'yes' && agree.agree02 === 'yes') {
			let data = signaturePad.toDataURL('image/png');

			if (signaturePad.isEmpty()) {
				alert("서명 후 저장해주세요.");
				return false;
			}

			signImgList(4, data);
			alert('저장되었습니다.');

			let thisEl = e.target.closest('.section');
			let nextEl = thisEl.nextElementSibling;
			let nextElFlag = nextEl && thisEl.nextElementSibling.classList.contains('section');

			if (nextElFlag) {
				let ua = window.navigator.userAgent;
				let msie = ua.indexOf("MSIE ");

				if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
					// If Internet Explorer
					window.scrollTo(0, nextEl.offsetTop)
				} else  {
					// If another browser
					// not support ios safari -_-;;
					window.scroll({
						top: nextEl.offsetTop,
						behavior: 'smooth'
					});
				}
			}
		} else {
			alert('개인정보 수집·이용 동의 및 제 3자에게 제공하는 것에 동의가 필요합니다.')
		}
	};

  const clearSign = () => {
		signaturePad.clear();
	};

  const setSignPad = () => {
		return(
			<div className={classes.signPad}>
				<canvas id={`signature${idx}`} className="signature" width="335px" height="200px"></canvas>
				<div className={classes.wrapBtn}>
					<Button
						className="clear"
						variant="contained"
						startIcon={<ClearIcon/>}
						onClick={clearSign}
					>
						Clear
					</Button>&nbsp;&nbsp;&nbsp;&nbsp;
					<Button
						className="save"
						variant="contained"
						color="primary"
						startIcon={<CreateIcon/>}
						onClick={(e) => saveSign(e)}
					>
						Save
					</Button>
				</div>
			</div>
		)
	}

  const signView = (imgSrc) => {
		if (!isEmpty(imgSrc)) {
			return(
				<div className={classes.signPad}>
					<img src={imgSrc} className="signature" alt="사인 이미지"/>
				</div>
			)
		}
	}

  return (
    <div className={`${classes.section} section`}>
      <p className={classes.title}>
        KB 증권 사용자 조사패널 구성을 위한 개인정보
        <br />
        수집·이용 및 제3자 제공 동의서
      </p>
      <p>
        ㈜피엑스디는 「개인정보 보호법」 등 관련 법령에 따라 귀하의 개인정보를 수집·이용하고 있습니다.
        본 동의서를 통해, 향후 진행될 <span className={classes.bold}>KB 증권의 다양한 사용자 조사 패널 선정</span>을 위해 제 3 자에게
        제공하고자 합니다. 아래 내용을 자세히 읽으신 후 동의 여부를 결정해 주십시오.
      </p>
      <p>
        1. 개인정보 수집·이용에 대한 동의
      </p>
      <span className={classes.bold}>[수집·이용 목적]</span>
      <ul>
        <li>* KB 증권 사용자 조사패널 풀(Pool) 구축 및 관리: 향후 진행될 다양한 사용자 조사(인터뷰, 설문,사용성 테스트 등)의 대상자 적합성 확인</li>
        <li>* 조사 참여 제안 및 섭외: 신규 조사 발생 시 연락 및 일정 조율</li>
        <li>* 기존 조사 이력 관리: 과거 조사 응답 내용을 바탕으로 한 정교한 패널 스크리닝</li>
      </ul>
      <span className={classes.bold}>[수집 항목]</span>
      <ul>
        <li>* <span className={classes.bold}>필수 항목</span>: 성명, 연령(연령대), 성별, 거주지역, 연락처(휴대폰 번호)</li>
        <li>* <span className={classes.bold}>추가 항목</span>: 본 조사에서 응답한 일체의 내용(금융 이용 행태 등), 과거 “KB 증권 M-able 앱자산/잔고 사용자조사” 참여 시 응답 내용</li>
      </ul>
      <span className={classes.bold}>[보유 및 이용 기간]</span>
      <ul>
        <li>* <span className={classes.bold}>동의일로부터 1 년</span> (단, 귀하가 동의를 철회하거나 삭제를 요청할 경우 지체 없이 파기합니다.)</li>
      </ul>
      <span className={classes.bold}>[동의 거부 권리 및 불이익]</span>
      <ul>
        <li>* 귀하는 위와 같은 개인정보 수집·이용에 동의하지 않을 권리가 있습니다. 다만, 동의를 거부하실경우 KB 증권 사용자 조사 패널 풀 등록이 불가하며, 향후 진행되는 조사 참여 및 사례비 지급대상에서 제외될 수 있습니다.</li>
      </ul>
			<br />
			<br />
      <p className={classes.title}>2. 개인정보의 제3자 제공에 대한 동의</p>
      <span className={classes.bold}> [제공받는 자]</span>
      <ul>
        <li>* KB 증권</li>
      </ul>
      <span className={classes.bold}>[제공 목적]</span>
      <ul>
        <li>* 조사 목적에 부합하는 패넱 선정 및 검증: KB 증권 서비스 이용 현황 등과 연계한 조사 대상자 필터링</li>
        <li>* 사용자 조사 결과 분석 및 연구: 금융 서비스 개선을 위한 연구 자료 활용</li>
      </ul>
      <span className={classes.bold}>[제공 항목]</span>
      <ul>
        <li>* 위 제 1 항에서 수집·이용하는 개인정보 및 조사 응답 데이터 전체</li>
      </ul>
      <span className={classes.bold}>[보유 및 이용 기간]</span>
      <ul>
        <li>* 위 제 3 항(수집·이용 기간)과 동일</li>
      </ul>
      <span className={classes.bold}>[동의 거부 권리 및 불이익]</span>
      <ul>
        <li>* 귀하는 개인정보의 제3자 제공에 동의하지 않을 권리가 있습니다. 다만, 동의를 거부하실 경우 KB 증권 측의 최종 패널 선정 과정에서 제외될 수 있어 실제 조사 참여가 어려울 수 있습니다</li>
      </ul>
      
      <p>위와 같이 개인정보를 수집&#183;이용 하는데 동의 하십니까?</p>
			<RadioGroup aria-label="위와 같이 개인정보를 수집·이용 하는데 동의 하십니까?" name="agree01" value={agree.agree01} onChange={handleChange}>
				<FormControlLabel value="yes" control={<Radio />} label="동의함" disabled={!isEmpty(signImg) || mode !== 'viewer'} />
				<FormControlLabel value="no" control={<Radio />} label="동의하지 않음" disabled={!isEmpty(signImg) || mode !== 'viewer'} />
			</RadioGroup>

			<p>위와 같이 개인정보를 제3자에게 제공하는 것에 동의 하십니까?</p>
			<RadioGroup aria-label="위와 같이 개인정보를 제3자에게 제공하는 것에 동의하십니까?" name="agree02" value={agree.agree02} onChange={handleChange}>
				<FormControlLabel value="yes" control={<Radio />} label="동의함" disabled={!isEmpty(signImg) || mode !== 'viewer'} />
				<FormControlLabel value="no" control={<Radio />} label="동의하지 않음" disabled={!isEmpty(signImg) || mode !== 'viewer'} />
			</RadioGroup>

			<p className={classes.alignRight}>{date}</p>
			<p className={classes.alignRight}>본인: <span className={classes.bold}>{userName}</span>(자필필요) 인</p>

			{ mode === 'view' && signView(signImg) }
			{ mode === 'print' && signView(signImg) }
			{ mode === 'viewer' && setSignPad() }
    </div>
  );
};

export default UserSurvey05;

